import Container from '@/components/Container';
import { ResourceEntity, TopicEntity } from '@/graphql/generated/graphql';
import { getAuthors } from '@/services/knowledge-hub/utils';
import Card from '@/components/Card';
import Button from '@/components/Button';
import { useKnowledgeHubStore } from './store/useKnowledgeHubStore';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Divider from '@/components/Divider';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';

export default function LatestByTheme({ topic }: { topic: TopicEntity }) {
  const { page, latestByTheme, latestByThemeMeta, t, filterActive, onClickMoreTheme } = useKnowledgeHubStore();

  return (
    <AnimatedFadeInComponent id={topic?.attributes?.topic || 'theme'}>
      <Container className=" !mt-sh-60">
        <div className=" last-divider-hidden col-span-12 lg:col-start-11 lg:col-end-3">
          {topic.attributes?.themes?.data.map((theme) => {
            const resourcesByTheme = latestByTheme[theme.attributes?.theme?.toString() || ''];
            const resourcesByThemeMeta = latestByThemeMeta[theme.attributes?.theme?.toString() || ''];

            const showMoreButton =
              (resourcesByThemeMeta?.meta?.pagination?.total || 0) > (resourcesByTheme?.length || 0);

            if (filterActive && filterActive !== theme.attributes?.theme?.toString()) return null;

            if (filterActive && !resourcesByTheme?.length)
              return (
                <div key={theme.id}>
                  <h3 className=" text-sh-md font-bold">{t(theme.attributes?.theme || '')}</h3>
                  <p key={theme.id}>No resources found</p>
                </div>
              );

            if (!filterActive && !resourcesByTheme?.length) {
              return null;
            }

            return (
              <div key={theme.id}>
                <h3 className=" text-sh-md font-bold">{t(theme.attributes?.theme || '')}</h3>
                {!resourcesByTheme?.length && <p className="py-4">No resources found</p>}
                <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 md:gap-4">
                  {resourcesByTheme?.map((resource: ResourceEntity) => {
                    return (
                      <Card
                        key={resource.id}
                        title={resource.attributes?.title || ''}
                        description={resource.attributes?.briefDescription || ''}
                        author={getAuthors(resource)}
                        link={`/knowledge-hub/slug/${resource.attributes?.slug}`}
                        tags={
                          <DefaultContentTemplateTags
                            duration={resource?.attributes?.duration?.toString() || ''}
                            tags={[resource?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
                            className="!mb-2 !mt-0"
                          />
                        }
                        image={{
                          url: resource.attributes?.cover.data?.attributes?.url || '',
                          alternativeText: resource.attributes?.cover.data?.attributes?.alternativeText || '',
                        }}
                      />
                    );
                  })}
                </div>
                {showMoreButton && (
                  <div className="mt-4 flex w-full justify-end">
                    <Button
                      theme="outline"
                      onClick={() => {
                        onClickMoreTheme(theme, (resourcesByThemeMeta?.meta?.pagination?.page || 1) + 1);
                      }}>
                      {page.page?.moreButotnTItle}
                    </Button>
                  </div>
                )}
                <Divider isBody />
              </div>
            );
          })}
        </div>
      </Container>
    </AnimatedFadeInComponent>
  );
}
